import React from 'react';
import { Box, Typography } from '@mui/material';
import { searchCandidateProfileQueryHistoryListSx } from 'modules/candidate-profile/styles';
import {
  ActionPopover,
  ActionOption
} from 'components/ActionPopover/ActionPopover';
import { MenuOptionProps } from 'modules/candidate-profile/hooks/useSearchCandidateProfileQueryConversationHistoryActions';

const UNTITLED_SEARCH_LABEL = 'Untitled search';

type SearchCandidateProfileQueryItem = {
  id: string;
  displayTitle?: string | null;
  isPinned?: boolean | null;
};

type SearchCandidateProfileQueryHistoryListItemsProps = {
  items: SearchCandidateProfileQueryItem[];
  getMenuOptions: (props: MenuOptionProps) => ActionOption[];
  onItemClick: (id: string) => void;
};

export const SearchCandidateProfileQueryHistoryListItems: React.FC<
  SearchCandidateProfileQueryHistoryListItemsProps
> = ({ items, getMenuOptions, onItemClick }) => {
  return (
    <Box sx={searchCandidateProfileQueryHistoryListSx.sectionList}>
      {items.map((item) => (
        <Box
          key={item.id}
          sx={searchCandidateProfileQueryHistoryListSx.listItem}
        >
          <Typography
            sx={searchCandidateProfileQueryHistoryListSx.listItemText}
            onClick={() => onItemClick(item.id)}
          >
            {item.displayTitle?.trim() || UNTITLED_SEARCH_LABEL}
          </Typography>
          <Box sx={searchCandidateProfileQueryHistoryListSx.menuButton}>
            <ActionPopover
              id={`search-candidate-profile-query-actions-${item.id}`}
              options={getMenuOptions({
                searchCandidateProfileQueryId: item.id,
                displayTitle: item.displayTitle ?? null,
                isPinned: !!item.isPinned
              })}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};
